import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Calendar, FileText, BarChart2, MessageSquare } from 'lucide-react';
export function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const navItems = [{
    icon: Home,
    label: 'Accueil',
    path: '/'
  }, {
    icon: Calendar,
    label: 'Congés',
    path: '/conges'
  }, {
    icon: FileText,
    label: 'Évaluations',
    path: '/evaluations'
  }, {
    icon: BarChart2,
    label: 'Sondages',
    path: '/sondages'
  }, {
    icon: MessageSquare,
    label: 'Feedback',
    path: '/performance'
  }];
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40" data-id="element-713">
      <div className="grid grid-cols-5 gap-1 p-2" data-id="element-714">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return <button key={item.path} onClick={() => navigate(item.path)} className={`flex flex-col items-center justify-center py-2 px-1 rounded-lg transition-colors ${isActive ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-715">
              <Icon className="h-6 w-6 mb-1" data-id="element-716" />
              <span className="text-xs font-medium" data-id="element-717">{item.label}</span>
            </button>;
      })}
      </div>
    </div>;
}